import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const examCalendar = lazy(() => import('../../container/exam-calendar'));

const ExamCalendar = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/examCalendar`} component={examCalendar}/>
        </Switch>
    );
};

export default ExamCalendar;